import React, { useState, useEffect } from "react";
import MaterialTable from "material-table";
import Axios from "axios";

import {
  MDBRow,
  MDBCol,
  MDBContainer,
  MDBIcon,
  MDBModal,
  MDBCard,
  MDBCardBody,
  MDBCardHeader,
  MDBCardFooter,
  MDBBtn,
  MDBBtnGroup,
} from "mdbreact";
import { Bounce, ToastContainer, toast } from "react-toastify";
import { makeStyles } from "@material-ui/core/styles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import PropTypes from "prop-types";
import "../css/scrollbar.css";

import AccessDenied from "../components/AccessDenied";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBoxesPacking,
  faCar,
  faCircleExclamation,
  faFileInvoice,
  faMoneyCheck,
  faLock,
  faMagnifyingGlassArrowRight,
  faScrewdriverWrench,
  faSpinner,
  faUser,
  faWandMagicSparkles,
  faPrint,
  faUserCheck,
  faCalendarCheck,
} from "@fortawesome/free-solid-svg-icons";

import { AppBar, Box, Typography } from "@material-ui/core";
import { useSelector } from "react-redux";
import AddEditCustomer from "../Customer/AddEditCustomer";
import CustomerInformation from "../Customer/CustomerInformation";
import VehicleCustomerView from "../Vehicle/VehicleCustomerView";
import { is } from "date-fns/locale";
import { set } from "date-fns";
import Appointment from "../Appointment/Appointment";
import AppointmentCustomerView from "../Appointment/AppointmentCustomerView";

const CustomerHome = (props) => {
  const bearer = {
    headers: {
      Authorization: "Bearer " + sessionStorage.getItem("hash"),
    },
  };
  let intTotalSales = useSelector((state) => state.sales.value);
  const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
      width: "100%",
      backgroundColor: theme.palette.background.paper,
    },
  }));
  const classes = useStyles();

  function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`scrollable-force-tabpanel-${index}`}
        aria-labelledby={`scrollable-force-tab-${index}`}
        {...other}
        className="p-0 m-0"
      >
        {value === index && (
          <Box p={0} m={0}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
  };
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  function a11yProps(index) {
    return {
      id: `scrollable-force-tab-${index}`,
      "aria-controls": `scrollable-force-tabpanel-${index}`,
    };
  }

  const [showPreloader, setPreloader] = useState("normal");

  const toastId = React.useRef(null);

  const notify = (message) => {
    toast(() => message, {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "dark",
      transition: Bounce,
      className: "font-weight-bold blue-text",
    });
  };

  const warning = (message) => {
    toast.error(() => message, {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "dark",
      transition: Bounce,
      className: "font-weight-bold white-text",
    });
  };

  const useMountEffect = (functionName) => useEffect(functionName, []);

  const TabSales = () => {
    return (
      <>
        <Tabs
          value={value}
          onChange={handleChange}
          //   variant="scrollable"
          scrollButtons="on"
          aria-label="scrollable"
          // className="cloudy-knoxville-gradient black-text"
          style={{ borderColor: "white" }}
          className="pb-0 mb-0"
          //   centered
        >
          <Tab
            label={<a className="blue-text font-weight-bold">Profile</a>}
            icon={
              <FontAwesomeIcon icon={faUser} size="4x" className="blue-text" />
            }
            {...a11yProps(0)}
          />
          <Tab
            label={<a className="blue-text font-weight-bold">Vehicles</a>}
            icon={
              <FontAwesomeIcon icon={faCar} size="4x" className="blue-text" />
            }
            {...a11yProps(1)}
          />
          <Tab
            label={<a className="blue-text font-weight-bold">APPOINTMENTS</a>}
            icon={
              <FontAwesomeIcon
                icon={faCalendarCheck}
                size="4x"
                className="blue-text"
              />
            }
            {...a11yProps(2)}
          />
        </Tabs>
      </>
    );
  };

  const [isTabsEnabled, setTabsEnabled] = useState(0);

  function checkTabs() {
    if (sessionStorage.getItem("msal.uc") === null) {
      setTabsEnabled(0);
      return;
    }

    Axios.get(
      props.apiServer +
        "/othertabsenabled?username=" +
        sessionStorage.getItem("msal.uc"),
      bearer
    )
      .then((res) => {
        setTabsEnabled(0);
        setTabsEnabled(res.data[0].tabsenabled);
      })

      .catch((error) => {
        console.log(error);
      });
  }

  useEffect(() => {
    checkTabs();
    if (value > 0 && isTabsEnabled === 0) {
      setValue(0);
      warning("Please complete your profile first.");
    }
  }, [value]);
  return (
    <React.Fragment>
      <MDBRow>
        <MDBCol md="12">
          <div className={classes.root}>
            {/* <AppBar
                      position="static"
                      color="cloudy-knoxville-gradient black-text"
                      
                      className="mt-4"
                    > */}
            <TabSales />

            {/* </AppBar> */}
            <hr />
            <TabPanel value={value} index={0}>
              <span className="h5-responsive font-weight-bold">Profile</span>
              &nbsp;|&nbsp;
              <span className="h6-responsive font-weight-bold brown-text">
                {sessionStorage.getItem("Email")}
              </span>
              <CustomerInformation
                deployURL={props.deployURL}
                apiServer={props.apiServer}
                apiServerHybrid={props.apiServerHybrid}
              />
            </TabPanel>
            <TabPanel value={value} index={1}>
              <VehicleCustomerView
                deployURL={props.deployURL}
                apiServer={props.apiServer}
                apiServerHybrid={props.apiServerHybrid}
              />
            </TabPanel>
            <TabPanel value={value} index={2}>
              <AppointmentCustomerView
                deployURL={props.deployURL}
                apiServer={props.apiServer}
                apiServerHybrid={props.apiServerHybrid}
              />
            </TabPanel>

            <hr />
            <TabSales />
          </div>
        </MDBCol>
      </MDBRow>

      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        transition={Bounce}
      ></ToastContainer>
    </React.Fragment>
  );
};

export default CustomerHome;
